<template>
  <b-modal
    id="duplicate-media-modal"
    :title="trans('duplicate')"
    :ok-title="trans('duplicate')"
    :ok-disabled="busy"
    :cancel-title="trans('cancel')"
    @ok="onDuplicate"
    @shown="onShown"
  >
    <b-form-group :label="trans('name')">
      <b-input v-model="name" :disabled="busy" />
    </b-form-group>
    <b-form-group v-if="organizations && organizations.length > 1" :label="trans('target_organization')">
      <b-form-select
        v-model="target_organization_id"
        :options="organizationOptions"
        :disabled="busy"
      ></b-form-select>
    </b-form-group>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      media: Object,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        name: null,
        target_organization_id: this.organization.id,
        organizations: null,
      }
    },
    computed: {
      organizationOptions() {
        return _.map(this.organizations || [], o => {
          return {
            value: o.id,
            text: o.name,
          }
        })
      },
      targetOrganizationName() {
        return _.reduce(this.organizations || [], (name, o) => {
          if (o.id == this.target_organization_id) name = o.name
          return name
        }, null)
      },
    },
    methods: {
      onShown() {
        this.busy = false
        this.error = null
        this.name = trans('copy_of') + ' ' + this.media.name
        this.target_organization_id = this.organization.id
        this.loadOrganizations()
      },
      loadOrganizations() {
        this.busy = true
        this.error = null
        let url = `/organization`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.organizations = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onDuplicate(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.target_organization_id}/media/${this.media.id}/duplicate`
        axios.post(url, {
          name: this.name,
          description: this.media.description,
        })
        .then(response => {
          this.busy = false
          let message = trans('copy_created')
          if (this.target_organization_id != this.organization.id) {
            message = trans('copy_created_in_org').replace(':org', this.targetOrganizationName)
          }
          if (this.target_organization_id == this.organization.id) this.$emit('duplicated', response.data)
          _.toastSuccess(this, message)
          this.$bvModal.hide('duplicate-media-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.duplicateMediaModal = this
    },
  }
</script>